<template>
  <div class="services-section">
    <ServicesTitle class="servicetitle scroll-hidden" v-scroll="'scroll-hidden'" />
    <test
      title="servicesSection.brandingTitle" 
      text="servicesSection.brandingText"
      logo="illu_webeasy_branding.png"
      class="scroll-hidden"
      v-scroll="'scroll-hidden'" 
    />
    <test 
      title="servicesSection.websiteTitle" 
      text="servicesSection.websiteText"
      logo="illu_webeasy_website.png" 
      :reverse="true"
      class="scroll-hidden"
      v-scroll="'scroll-hidden'" 
    />
    <test 
      title="servicesSection.mobileTitle" 
      text="servicesSection.mobileText"
      logo="illu_webeasy_mobile_app.png"
      class="scroll-hidden"
      v-scroll="'scroll-hidden'" 
    />
    <test 
      title="servicesSection.ecommerceTitle" 
      text="servicesSection.ecommerceText"
      logo="illu_webeasy_ecommerce.png" 
      :reverse="true"
      class="scroll-hidden"
      v-scroll="'scroll-hidden'" 
    />
  </div>
</template>

<script>
import ServicesTitle from '@/components/ServicesTitle.vue'
import test from '@/components/test.vue'

export default {
  name: 'ServicesSection',
  components: {
    ServicesTitle,
    test
  }
}
</script>

<style scoped>
.services-section {
  display: flex;
  flex-direction: column;
  margin-top: 10vh;
  margin-bottom: 2vh;
}
.servicetitle {
  margin-bottom: 5vh;
}
</style>
